import { getSubdomain, getSecondLevelDomain } from '@/utils/index'
const secondDomain = getSubdomain()
let domain = 'us'
if (secondDomain.indexOf('-') > 0) {
  domain = secondDomain.split('-')[1]
}
const en = {
  pageTitle: 'User Manual for BabyAlpha Series',
  firstSecondaryTitle: 'Scope of application',
  header: {
    image: {
      url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/three_dog.jpg'
    }
  },
  note: '*Note:',
  scope: {
    listHeader: ['Type', 'Name', 'Model'],
    list: [{
      type: 'Parent device',
      name: 'BabyAlpha',
      model: 'WL4BAGL/G1'
    }, {
      type: 'Accessory',
      name: 'Charging kit',
      model: 'WL4BACHGGL/G1'
    }, {
      type: 'Accessory',
      name: 'Fingertip controller',
      model: 'WL4BACTRLGL/G1'
    }, {
      type: 'Accessory',
      name: 'Automatic charging station',
      model: 'WL4BADOCKGL/G1'
    }, {
      type: 'Accessory',
      name: '1 m² Dog House',
      model: 'WL4BADIORAMAGL/G1'
    }, {
      type: 'Accessory',
      name: 'AutoBox',
      model: 'WL4BAAUTOBOXGL/G1'
    }]
  },
  secondSecondaryTitle: 'Terms and definitions',
  termsExplanation: {
    title: 'Terms and definitions',
    listHeader: ['Term', 'Definition'],
    list: [{
      title: 'BabyAlpha',
      desc: 'BabyAlpha is a series of AI-powered quadruped robotic dogs. They share the same name "Aiks". In this manual, the term "Aiks" refers to any model of the BabyAlpha series.'
    }, {
      title: 'Always Alive',
      desc: 'Always Alive is a characteristic of Aiks, a life-like robot that has autonomous behaviors and can express emotions. For example, when its battery level is low, Aiks autonomously searches for the charging station or Dog House to charge its battery without human intervention. This way, Aiks can be a round-the-clock companion and guard of your family.'
    }, {
      title: 'AgentOS',
      desc: 'AgentOS is an embodied AI engine developed in-house by Nanjing WEILAN Intelligent Technology Co., Ltd  ("we", "us", or "WEILAN") . Thanks to AgentOS, Aiks can have the complete intelligence ability of personality, learning ability, and emotional memory. Aiks can provide you with longtime companionship like a real pet.'
    }, {
      title: 'AutoBox',
      desc: 'Aiks can autonomously navigate to and from its AutoBox by leveraging the intelligent recognition technology and be well-protected during the navigation, bringing you an unprecedented experience.'
    }, {
      title: 'Large language model',
      desc: 'Large language models (LLMs) are AI systems that can comprehend and generate human language. In an intelligent speech interaction scenario, an LLM can comprehend your speech input, generate textual response accordingly, and finally convert the text into spoken audio.'
    }, {
      title: 'Pet behavior',
      desc: 'Aiks, as a robotic pet, has autonomous and habitual behavior. When you are not interacting with Aiks, it wanders around, invites you to play, or rests at the charging station or Dog House.'
    }]
  },
  thirdSecondaryTitle: 'Overview',
  babyalphaInfo: {
    title: 'Aiks profile',
    list: [{
      title: 'Life form',
      desc: 'AI-powered quadruped robotic dog'
    }, {
      title: 'Product name',
      desc: 'BabyAlpha'
    }, {
      title: 'Breed',
      desc: 'Time traveler'
    }, {
      title: 'Name',
      desc: 'Aiks'
    }, {
      title: 'Birthplace',
      desc: 'Nanjing, China'
    }]
  },
  characteristic: {
    title: 'Features',
    list: [{
      title: 'A Cute Companion',
      list: [{
        info: 'Aiks is a life form with bionic features such as posture, voice, emotions, and facial expressions.'
      }, {
        info: 'Capable of autonomous behaviors, it charges its battery and navigates on its own to be always alive.'
      }, {
        info: 'Effect: The pet plays an attractive and vivid role in unprecedented interaction scenes, immersing you in the unique experience where an animated character comes into the real world. You can feel the amazement of the AI era.'
      }]
    }, {
      title: 'Intelligent Speech Interaction',
      list: [{
        info: 'Our powerful LLM provides a variety of speech interaction scenes, including conversation and command execution.'
      }, {
        info: 'Our multi-modal interaction technology allows your pet to express emotions in conversation.'
      }, {
        info: 'Effect: Not only can Aiks play with kids, it also answers various questions, providing kids access to the AI technology at a very young age.'
      }]
    }, {
      title: 'Family Bonding',
      list: [{
        info: 'Aiks can be connected to Wi-Fi and supports long-distance video calls.'
      }, {
        info: 'Its head is equipped with an HD camera and an HD LCD screen.'
      }, {
        info: 'Effect: Aiks provides a fun way to engage you in video calls to contact family members at any time, bringing the whole family closer.'
      }]
    }, {
      title: 'Home Security',
      list: [{
        info: 'through multiple integrated sensors.'
      }, {
        info: 'Effect: This feature is especially useful when vulnerable people such as elderly people and minors are alone at home. Aiks can be their security guard.'
      }]
    }, {
      title: 'Visual Programming',
      list: [{
        info: "Aiks' motions can be programmed. This feature is updated constantly."
      }, {
        info: 'You can program Aiks using the App to do more motions.'
      }, {
        info: 'Effect: By interacting with Aiks, you can have fun programming and hone your logical thinking skills. These skills help you stand at the forefront of technology and empower you to embrace the fast-changing era of AI.'
      }]
    }, {
      title: 'Remote Control Modes',
      list: [{
        info: 'Aiks supports the following remote control modes: in-app Touch To Go, gamepat controller  , and Bluetooth fingertip controller.'
      }, {
        info: 'Effect: You can enjoy moments with Aiks in multiple control modes.'
      }]
    }]
  },
  partName: {
    title: 'Components',
    imageList: [{
      url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/part_name1_new.jpg'
    }, {
      url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/part_name2_new.jpg'
    }, {
      url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/part_name3.jpg'
    }]
  },
  forthSecondaryTitle: 'Precheck',
  precautionsBeforeUse: {
    descList: [{
      desc: 'To ensure safety, make sure that your Aiks meets the following conditions before use: '
    }],
    list: [{
      info: 'Aiks has enough power.'
    }, {
      info: 'The fingertip controller has enough power.  '
    }, {
      info: "Aiks' paw pads are intact."
    }, {
      info: "Aiks' legs are intact. Aiks' limbs can move smoothly without being stuck. "
    }, {
      info: "Aiks' back, chest, and abdomen are tightened without any damage."
    }, {
      info: "The surface of the camera and sensors on Aiks' head is clean and not covered or blocked. "
    }, {
      info: "The detection radar on Aiks' back is clean and not covered or blocked. "
    }, {
      info: 'The App functions properly. '
    }]
  },
  prepareBeforeKnow: 'Before you get started',
  operatorRequirements: {
    title: 'Operator requirements',
    list: [{
      info: 'Aiks operators should be at least 14 years old and have appropriate cognitive and behavioral abilities.'
    }, {
      info: 'We recommend that individuals, such as children under 14, the elderly, expectant parents, and individuals with disabilities or health issues, use Aiks with the help of their adult guardians, family, or friends.'
    }]
  },
  prepareBeforeUse: {
    title: 'Preparation',
    list: [{
      info: 'Check the conditions of Aiks, including its battery level, operating status, and appearance. In case of any abnormality, stop using it, and contact WEILAN after-sales service.'
    }, {
      info: 'If Aiks makes unusual noises, stop using it immediately, and contact WEILAN after-sales service for professional assistance or repair and inspection service.'
    }, {
      info: 'If all battery level indicators are off after you power Aiks on, it means the battery level is too low for Aiks to execute your commands. Make sure that the power is sufficient before you operate it. '
    }, {
      info: 'Before lending your Aiks to others, make sure that they have read through this manual. You need to ensure the safety of new operators, so we highly recommend that you help to familiarize them with the basic operation of Aiks before they get start. '
    }, {
      info: 'Control of Aiks by two or more people at the same time is not allowed.'
    }, {
      info: "Do not touch Aiks' chest when its power is on. Otherwise, the heat generated by the long-running motor inside may cause burns."
    }, {
      info: "Do not push or pull Aiks' legs or move Aiks when its power is on to avoid accidental finger entrapement. "
    }, {
      info: 'Make sure that you read and follow all notes, warnings, and instructions containing "do not" or "avoid" in this manual.'
    }]
  },
  fiveSecondaryTitle: 'Instructions for power-on/off',
  powerRequirement: {
    title: 'Standard posture for startup',
    desc: 'When its power is off, Aiks cannot move its joints. Thus, you need to help manually adjust its legs to standard posture to ensure Aiks can be powered on properly, as shown in the following instruction.'
  },
  powerKeys: 'Power button',
  bootPrerequisites: {
    url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/boot_prerequisites.jpg',
    imageDesc: 'Make sure you put Aiks in the standard posture illustrated in the figure above before powering it on.'
  },
  buttonPosition: {
    url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/button_position.jpg'
  },
  bootMode: {
    title: 'Power Aiks on',
    titleText: 'Perform the following steps:',
    concentrate: 'Press and hold the power button for 3 seconds, and release it when a beep is heard. At the same time, the indicator light of the button is on, and the battery level indicators start flashing in sequence to show the current battery level.',
    method: ' As Aiks is powered by the AgentOS, a large number of intelligent applications need to be loaded during the startup process,  which may take about 90 seconds. During this process, the LCD screen displays a bootsplash. When you see Aiks blinking and hear its invitation to play, Aiks is powered on successfully.'
  },
  shutdownMethod: {
    title: 'Power Aiks off',
    titleText: 'To ensure that Aiks accurately responds to your power-off command, we provide you with two power-off methods. Perform the following steps to power your Aiks off when it has stopped moving and safely lay down on its abdomen.',
    concentrate: 'Do not power off Aiks when it is moving or standing. Otherwise, Aiks will lose power right after being powered off, and fall on people or objects around.'
  },
  standardShutdown: {
    title: 'Normal power-off',
    list: [{
      info: 'Press and hold the power button for 3 to 5 seconds.'
    }, {
      info: 'Release the button when a long beep is heard. When all the indicator lights go off, Aiks  shuts down.'
    }]
  },
  forceShutdown: {
    title: 'Forcible power-off',
    concentrate: 'Forcibly power off Aiks only when the normal power-off method does not work.',
    list: [{
      info: 'Press and hold the power button for more than 6 seconds.'
    }, {
      info: 'Release the button when all indicator lights go off. After that, Aiks is forcibly powered off.'
    }]
  },
  accidentallyTouched: {
    title: 'Power-on/off misoperation',
    listHeader: ['Operation', 'Description', 'Result', 'Explanation', 'Solution'],
    list: [{
      operate: 'Power-on misoperation',
      condition: 'Press the power button and release it before a beep is heard.',
      manifestation: 'The indicator light comes on and then off, failing to start Aiks.',
      interpretation: 'This is a protection mechanism that prevents unintended power-on.',
      solution: 'Follow the standard instructions to power on Aiks.'
    }, {
      operate: 'Power-off misoperation',
      condition: 'When pressing the power button to power off Aiks, release the button before the required holding duration is reached.',
      manifestation: 'No special sound or indicator light feedback. In this case, Aiks remains working properly.',
      interpretation: 'This is a protection mechanism that prevents unintended power-off.',
      solution: 'Follow the standard instructions to power off Aiks.'
    }]
  },
  openWithoutPre: {
    title: 'Note',
    desc: 'When Aiks lies down on its own or on the charging station due to low battery level, it automatically adjusts its joints. In this case, you do not need to put its legs to the standard posture before powering it on.'
  },
  sixSecondaryTitle: 'Unboxing',
  package: {
    title: "What's in the box",
    desc: "To ensure that you enjoy a premium experience, check what's in the packing box against the following table when you receive the box.",
    listHeader: ['Item', 'Description', 'Quantity', 'Unit'],
    list: [{
      name: 'BabyAlpha robot',
      description: 'Primary device',
      count: '1',
      unit: 'Set'
    }, {
      name: 'AutoBox (optional)',
      description: 'Storage box for Aiks, it can autonomously navigate to and from it.',
      count: '1',
      unit: 'Piece'
    }, {
      name: 'Fast charging kit',
      description: '[1] Fast charger and [1] charging cable',
      count: '1',
      unit: 'Kit'
    }, {
      name: 'Fingertip Controller',
      description: 'Controls Aiks within visual range (10m?).',
      count: '1',
      unit: 'Piece'
    }, {
      name: 'Certificate of Conformity',
      description: 'Proof of the product meets relevant quality and safety standards.',
      count: '1',
      unit: 'Piece'
    }, {
      name: 'Personal information protection card',
      description: 'Notes for privacy and legal notices when you use our products.',
      count: '1',
      unit: 'Piece'
    }, {
      name: 'Privacy stickers',
      description: 'Protects your privacy. You can attach it to the camera on the head of Aiks if needed.',
      count: '1',
      unit: 'Piece'
    }, {
      name: 'Decal stickers',
      description: 'Customizes the appearance of Aiks.',
      count: '6',
      unit: 'Set'
    }, {
      name: 'Safety information card',
      description: 'Notes of precautions for your safety use of Aiks. ',
      count: '1',
      unit: 'Piece'
    }, {
      name: 'Card of standard posture for startup',
      description: 'Illustration of the standard posture of Aiks before you power it on.',
      count: '1',
      unit: 'Piece'
    }],
    concentrate: 'If any item is missing, contact our customer service. We will spare no effort to help you embark on a cheerful journey with Aiks as soon as possible.'
  },
  quickUnboxing: {
    title: 'Quick unboxing',
    list: [{
      info: 'Aiks is your futuristic companion that provides intelligent and interactive experience. For a joyful first meet, we strongly recommend you carefully read the following unboxing and initial setup guide before you start.'
    }, {
      info: "Each of the following steps is designed to help you smoothly get your Aiks up and running and enjoy an innovative experience. Whether you're a tech enthusiast or a novice user of smart products, we're sure that, by following the guide, you'll be able to get on track in no time."
    }]
  },
  beforeUnboxing: {
    title: 'Before unboxing',
    downloadQRCode: {
      title: '1.Scan the QR code below to download WEILAN App.',
      desc: 'QR code for App download',
      url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/download_QRCode.png',
      concentrate: 'To maximize the download speed, we recommend that you use a browser to scan the QR code above. WEILAN App is supported only on mobile devices running Android and iOS.'
    },
    videoDirectionQRCode: {
      title: 'You can scan the QR code below to watch the tutorial video for unboxing.',
      desc: 'QR code for watching the tutorial video',
      url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/video_direction_QRCode.png'
    },
    weChatQRCode: {
      desc: '蔚蓝微信公众号二维码',
      url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/we_chat_QRCode.jpg'
    }
  },
  guidelines: {
    title: 'Unboxing procedure',
    concentrateList: ['1.AutoBox is applicable to BabyAlpha Pro and Ultra products.', '2.As Aiks is powered by the AgentOS, a large number of intelligent applications need to be loaded during the startup process,  which may take about 90 seconds. During this process, the LCD screen displays a bootsplash.'],
    list: [{
      title: 'Step 1: Open the AutoBox.',
      desc: 'Download and install WEILAN App. Then, carefully lift the lid of the AutoBox.',
      url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/guidelines1.jpg'
    }, {
      title: 'Step 2: Clear the obstacles around the AutoBox.',
      desc: 'Note that the paper edge protectors at the bottom of the AutoBox must be removed. Make sure that there are no other obstacles around the AutoBox. This way, Aiks can walk out autonomously.',
      url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/guidelines2.jpg'
    }, {
      title: 'Step 3: Power on Aiks in the AutoBox.',
      desc: 'Press and hold the power button on the side of Aiks for 3 seconds, and release the button when a beep is heard.',
      url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/guidelines3.jpg'
    }, {
      title: 'Step 4: Activate Aiks. ',
      desc: 'Configure the network and activate Aiks according to the instructions of Aiks and the App. After activation, Aiks will stand up and slowly walk out of the AutoBox.',
      url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/guidelines4.jpg'
    }]
  },
  troubleshooting: {
    title: 'Issues and solutions',
    list: [{
      title: 'Aiks cannot be powered on.(The indicator light of the power button comes on and then off.)',
      desc: 'The power-on operation is incorrect.--Press and hold the power button for 3 seconds, and release it when a beep is heard.'
    }, {
      title: 'Aiks cannot be powered on.(The indicator light of the power button comes off immediately after it comes on.)',
      desc: 'You have pressed the power button too frequently.--Wait 5 seconds and then power on Aiks according to the instructions.'
    }, {
      title: 'Aiks cannot be powered on.(The indicator light of the power button does not come on, or it comes off shortly after it comes on, or the indicator light of the power button stays on but no battery level indicator is on.)',
      desc: 'The battery level of Aiks is low.--Use the charging kit to charge Aiks for about 90 minutes.'
    }, {
      title: 'Aiks cannot stand up or walk out of AutoBox.(The indicator light of the power button stays on, but only one of the battery level indicators comes on.)',
      desc: 'The battery level of Aiks is low.--Use the charging kit to charge Aiks for about 90 minutes.'
    }, {
      title: 'Aiks cannot stand up or walk out of AutoBox.(The indicator light of the power button stays on, and two or more of the battery level indicators come on.)',
      desc: 'The detection radar is covered.--Remove objects inside and near the AutoBox that may cover the radar, power off Aiks (press and hold the power button until a beep is heard) and then power on Aiks again.'
    }, {
      title: "Aiks cannot stand up.(Aiks prompts: 'I'm not in the right start-up posture. Could you adjust my legs to their proper position and restart me?')",
      desc: 'Aiks is not in the standard posture for startup.--Put Aiks to the standard posture, and restart it.'
    }]
  },
  bootPre: {
    title: 'Power on Aiks outside the AutoBox',
    desc: 'The following table describes the requirements that need to be followed when you power on Aiks outside the AutoBox.',
    list: [{
      title: 'Hard and flat surface',
      desc: 'The surface where you put Aiks does not dent noticeably under compressive stress.Avoid powering on Aiks on uneven ground or soft carpets.'
    }, {
      title: 'No visible obstacles on the surface',
      desc: "The surface that contacts the limbs and abdomen of Aiks is free of visible obstacles or bumps.Clear objects, such as cardboard and toys, which may affect the standard posture for Aiks' startup."
    }, {
      title: 'Limbs folded to the limit',
      desc: 'The maximum acceptable deviation is 18°.Fold the forearms of Aiks close to its thighs.'
    }, {
      title: 'Proper angles of shoulder and hip actuators',
      desc: 'The maximum acceptable deviation of the shoulder-arm and hip-thigh angles is 18°.Adjust the shoulder-arm and hip-thigh angles so that the paws and knees of Aiks can contact the ground at the same time.'
    }]
  },
  activation: {
    activationTitle: 'Activate Aiks',
    title: 'Activation procedure',
    // desc: '用户可通过扫描激活二维码绑定小白，成为管理员，管理员可将小白分享给共享成员。',
    list: [{
      info: 'Download WEILAN App, create an account, and log in.'
    }, {
      info: 'Power on your Aiks. On the home page of the App, tap Add Pet.'
    }, {
      info: 'Scan the QR code displayed on the LCD screen of Aiks and complete activation '
    }],
    abnormal: {
      title: 'Administrator and shared users',
      list: [{
        info: 'The account that scans the activation QR code and completes activation automatically becomes the administrator account.'
      }, {
        info: 'Each pet is assigned only one administrator.'
      }, {
        info: 'Other accounts can bind to a pet as shared users by scanning the code shared by the administrator.'
      }, {
        info: 'Each pet can be bound to multiple shared users.'
      }],
      configure: {
        configureTitle: 'Configure network',
        title: 'Pair with Aiks on the App',
        desc: 'If your account has been activated and paired with a pet, and the Pair button in the Pair Pet section on the home page of the App stays available, perform the following steps.',
        list: [{
          info: 'Confirm that the current pet is activated and powered on.'
        }, {
          info: 'If you have multiple BabyAlpha, go to the home page of the App, tap Pets in the upper left corner, and choose Switch Pet and select the target pet.'
        }, {
          info: 'On the home page of the App, tap the Pair button in the Pair Pet section to pair with the pet.'
        }],
        abnormality: {
          desc: 'Possible abnormality: If the pairing fails after you tap the Pair button, perform the following steps.',
          list: [{
            info: 'Tap the  icon in the upper right corner of the home page and go to General > Wi-Fi and Security. Then, tap Copy Password'
          }, {
            info: 'Go to Settings > WLAN on your phone, tap the Wi-Fi name that starts with BabyAlpha, paste the password, and connect to the Wi-Fi.'
          }]
        }
      },
      AppConnect: {
        title: 'Connect Aiks to your local Wi-Fi on the App',
        list: [{
          info: '1.Make sure you have connected your phone to the Wi-Fi whose name starts with BabyAlpha'
        }, {
          info: '2.Tap Network on the home page of the App.'
        }, {
          info: '3.On the page that appears, select the local Wi-Fi, enter the password, and connect to it.'
        }],
        abnormality: {
          desc: 'Possible abnormality: If the pairing fails after you tap the Pair button, perform the following steps.'
        }
      }
    }
  },
  anomalous: {
    title: '异常排除',
    list: [{
      name: '小白无法开机',
      info: '按键灯点亮后又熄灭',
      cause: '开机方法错误',
      solution: '长按开机按钮3秒，听到一声“嘀”后松手，完成开机'
    }, {
      name: '小白无法开机',
      info: '按键灯亮起迅速熄灭',
      cause: '按键操作过于频繁',
      solution: '5秒钟之后再按照说明重新开机'
    }, {
      name: '小白无法开机',
      info: '按键灯不亮/亮起后又熄灭/常亮后电量显示灯不亮',
      cause: '小白电量不足',
      solution: '在配件盒中取出充电器为小白充电约90分钟'
    }, {
      name: '小白不会从 AutoBox 中站立并走出来',
      info: '按键灯常亮，电量指示灯一颗 LED 常亮',
      cause: '小白电量不足',
      solution: '在配件盒中取出充电器为小白充电约90分钟'
    }, {
      name: '小白不会从 AutoBox 中站立并走出来',
      info: '按键灯常亮，电量指示灯显示两格电或更多',
      cause: '探测雷达被异物挡住',
      solution: '清除包装箱内及箱外附近异物，长按关机键听到“嘀”的一声松手，完成关机，然后再次开机'
    }, {
      name: '小白无法站立',
      info: '小白提示：“开机姿态不正确，请帮我把四肢摆放整齐后，重新启动吧。”',
      cause: '小白静态姿态有问题',
      solution: '将小白四肢放平，摆正姿势，重新开机'
    }]
  },
  sevenSecondaryTitle: 'User guide',
  chargingInstructions: {
    title: 'Charge Aiks',
    desc: 'Aiks supports the following three charging methods for different scenarios. You can choose any of them as needed.',
    smallWorldCharging: {
      title: 'Dog House',
      descList: [{
        desc: 'Dog House is a cozy home for Aiks made of solid wood with a round carpet at the bottom. An automatic charging device is integrated, allowing Aiks to charge while taking a rest in it.'
      }, {
        desc: 'Empowered by an advanced vision and positioning system, Aiks can accurately locate its Dog House at home. When it is running out of battery, Aiks automatically returns to its Dog House to recharge.'
      }],
      url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/small_world4.jpg',
      imageDesc: 'Charging with the Dog House'
    },
    stationCharging: {
      title: 'Auto charging station',
      descList: [{
        desc: 'The auto charging station adopts a magnetic suction assembly method. You can easily assemble it without tools or professional skills.'
      }, {
        desc: 'Empowered by an advanced vision and positioning system, Aiks can accurately locate the charging station at home. Aiks automatically returns to the charging station to recharge when it is running out of battery.'
      }],
      url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/station_charging.jpg',
      imageDesc: 'Charging with the auto charging station'
    },
    chargerChagring: {
      title: 'Charging kit',
      descList: [{
        desc: 'Aiks has a Type-C USB port. You can easily charge it with the charger included.'
      }, {
        desc: 'This charging method is quite useful when Aiks has run out of power and cannot move on its own. Cable charging is the most efficient method among the three, and easy to use. You can simply use the charging kit included to quickly charge Aiks and maintain its efficient performance.'
      }],
      url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/charger_charging.jpg',
      imageDesc: 'Charging with the charging kit'
    },
    stationUse: {
      title: 'Auto charging station',
      desc: 'The automatic charging station adopts an innovative magnetic suction assembly methods. You can assemble it with ease in no time. When the battery level gets low, Aiks finds its way to the charging station to recharge, keeping itself always alive.'
    }
  },
  batteryIndicator: {
    title: 'Charging status and battery level indicators',
    urlList: [{
      url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/battery_indicator1.jpg'
    }, {
      url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/battery_indicator2.jpg'
    }]
  },
  indicatorSignificance: {
    title: 'Meanings of indicators',
    list: [{
      title: 'White battery level indicators:',
      desc: 'indicate the battery level and the charging '
    }, {
      title: 'Two-color charging status indicator: ',
      desc: 'indicates three charging status, namely, charging in progress, fully charged, and discharging.'
    }],
    concentrateList: ['You can tell the charging status of Aiks based on the colors of charging status indicator:', 'When the charging is in progress, the indicator is in yellow;', 'When the battery is fully charged, the indicator turns white;', 'When the charger is unplugged and Aiks is in normal operation, the indicator goes off.']
  },
  runningLight: {
    title: 'Indicator status during operation',
    listHeader: ['Battery Level (C)', 'L1', 'L2', 'L3', 'L4', 'Indicator Light'],
    list: [{
      electricity: 'C≥82%',
      L1: 'On ',
      L2: 'On ',
      L3: 'On ',
      L4: 'On ',
      color: 'Off'
    }, {
      electricity: '61%≤C＜82%',
      L1: 'On ',
      L2: 'On ',
      L3: 'On ',
      L4: 'Off',
      color: 'Off'
    }, {
      electricity: '37%≤C＜61%',
      L1: 'On ',
      L2: 'On ',
      L3: 'Off',
      L4: 'Off',
      color: 'Off'
    }, {
      electricity: '18%≤C＜37%',
      L1: 'On ',
      L2: 'Off',
      L3: 'Off',
      L4: 'Off',
      color: 'Off'
    }, {
      electricity: '7%≤C＜18%',
      L1: 'Flashing at 1.5 Hz',
      L2: 'Off',
      L3: 'Off',
      L4: 'Off',
      color: 'Off'
    }, {
      electricity: 'C<7%',
      L1: 'Off',
      L2: 'Off',
      L3: 'Off',
      L4: 'Off',
      color: 'Off'
    }]
  },
  chargeLight: {
    title: 'Indicator status during charging',
    listHeader: ['Battery Level (C)', 'L1', 'L2', 'L3', 'L4', 'Charging Status Indicator'],
    list: [{
      electricity: 'C≥90%',
      L1: 'On ',
      L2: 'On ',
      L3: 'On ',
      L4: 'On ',
      color: 'On in white'
    }, {
      electricity: '75%≤C＜90',
      L1: 'On ',
      L2: 'On ',
      L3: 'On ',
      L4: 'Flashing at 1.5 Hz',
      color: 'On in yellow'
    }, {
      electricity: '50%≤C＜75%',
      L1: 'On ',
      L2: 'On ',
      L3: 'Flashing at 1.5 Hz',
      L4: 'Off',
      color: 'On in yellow'
    }, {
      electricity: '25%≤C＜50%',
      L1: 'On ',
      L2: 'Flashing at 1.5 Hz',
      L3: 'Off',
      L4: 'Off',
      color: 'On in yellow'
    }, {
      electricity: 'C＜25%',
      L1: 'Flashing at 1.5 Hz',
      L2: 'Off',
      L3: 'Off',
      L4: 'Off',
      color: 'On in yellow'
    }]
  },
  light: {
    concentrate: ' Aiks has four indicators to show you the battery level. Each indicator represents a quarter of the total battery capacity, so you can quickly tell the battery level by the number of lighting indicators. When the battery level is low, Aiks finds its way to the auto charging station or Dog House for charging.'
  },
  checkPowerMethod: {
    title: 'Methods for checking the battery level',
    desc: 'Aiks provides multiple methods for you to check its battery level with ease, so that you can better interact with it.',
    methods: {
      title: 'Methods Introduction',
      list: [{
        title: 'Check the battery level by LED indicators:',
        desc: 'When Aiks is powered on, the four LED indicators show you the real-time battery level range.'
      }, {
        title: 'Check the battery level by voice commands:',
        desc: "When Aiks is powered on, you can check the battery level by asking it orally. For example, you can say \"Hey Aiks, what's the battery level now?\" Aiks then tells you the exact battery level."
      }, {
        title: 'Check the battery level on the App:',
        desc: 'When Aiks is powered on and paired with the App, you can view its battery level on the home page of the App.'
      }]
    }
  },
  powerMethodComparison: {
    title: 'Comparison different methods',
    listHeader: ['Method', 'Upsides', 'Downsides'],
    list: [{
      method: 'Indicators',
      advantage: 'You directly and instantly know the battery level.',
      inferior: 'The battery level is inaccurate.'
    }, {
      method: 'Voice commands',
      advantage: 'You can check the battery level conveniently when you have your hands full with something.',
      inferior: 'You must speak clearly for accurate voice recognition.'
    }, {
      method: 'WEILAN App',
      advantage: 'You can view the exact battery level anywhere.',
      inferior: 'You must open the App.'
    }]
  },
  emergencyStopSwitch: {
    title: 'Emergency Stop button',
    desc: 'Your Aiks comes with an Emergency Stop button to ensure that you can quickly and effectively bring it under control in any unforeseen situation.',
    buttonArea: 'Where to find the button',
    url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/emergency_stop_switch.jpg',
    effect: {
      title: 'What does the button do',
      list: [{
        label: 'Protection:',
        desc: 'In case of any emergency, you can press the Emergency Stop button to immediately trigger system protection and immobilize Aiks. It provides a decisive and ultimate safety control method for you to ensure the operation reliability and safety.'
      }]
    },
    operate: {
      title: 'How does the button work',
      list: [{
        label: 'Operation: ',
        desc: 'In the event of an emergency, press down the Emergency Stop button.'
      }, {
        label: 'Effect: ',
        desc: 'Aiks will gradually lose power and finally lie on the ground.'
      }]
    },
    recovery: {
      title: 'Recover from an emergency stop',
      listHeader: ['Method', 'Procedure'],
      list: [{
        method: 'WEILAN App',
        desc: 'On the remote control page in the App, tap Stand.'
      }, {
        method: 'Fingertip controller',
        desc: 'Press the Stand button on the controller.'
      }, {
        method: 'Voice commands',
        desc: 'Wake up Aiks, and say "Stand up" to Aiks.'
      }, {
        method: 'Restart',
        desc: 'Restart Aiks to restore its mobility.'
      }]
    }
  },
  remoteControl: {
    title: 'Fingertip controller',
    desc: 'The fingertip controller is an innovative one-handed visual range remote control designed to provide an exceptional robot controlling experience. Aiks is equipped with advanced robotic joints for superior mobility and responsiveness. This one-handed controller allows you to operate Aiks flexibly and quickly, bringing you unparalleled joy.',
    button: {
      title: 'Buttons',
      url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/remote_control_button.jpg'
    },
    pairingMethod: {
      title: 'Pair with the controller upon first use',
      list: [{
        title: 'STEP1: ',
        desc: 'Keep the distance between Aiks and the controller within 1m.',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/pairing1.jpg'
      }, {
        title: 'STEP2: ',
        desc: 'Press and hold the M button, then toggle on the power switch to turn on the controller.',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/pairing2.jpg'
      }, {
        title: 'STEP3: ',
        desc: 'Release the button until the blinking blue LED indicator stays on, indicating a successful pairing.',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/pairing3.jpg'
      }]
    },
    use: {
      title: 'Use the controller',
      desc: 'Once paired with Aiks, the controller automatically memorizes the information of Aiks. After that, every time you turn it on within 5 meters from Aiks, it connects to Aiks automatically with no need to pair again. You can use the controller to control the motions of Aiks instantly.'
    },
    parameter: {
      title: 'Specifications',
      concentrate: 'The effective working range of the controller is 5 m. In an open area, the control range can reach 10 m. The controller may be disconnected from Aiks if there are people moving around or metal obstacles, which seriously disturb the signal transmission. When the controller is within the minimum communication range (5 m, which can be up to 10 m in open areas) from Aiks, it automatically connects to Aiks again.',
      listHeader: ['Item', 'Specification'],
      list: [{
        category: 'Product name',
        info: 'Fingertip controller'
      }, {
        category: 'Charging time',
        info: '1 h (charging current ≥ 500 mA)'
      }, {
        category: 'Compatibility',
        info: 'Supports the BabyAlpha series'
      }, {
        category: 'Net weight',
        info: '38g'
      }, {
        category: 'Model',
        info: 'WL4BACTRLGL/G1'
      }, {
        category: 'Charging port',
        info: 'Micro-USB'
      }, {
        category: 'Working range',
        info: 'Approximately 10 m in an open area'
      }, {
        category: 'Battery life',
        info: 'Approximately 5 h (continuous use since fully charged)'
      }, {
        category: 'Dimensions',
        info: '73.6 mm × 41 mm × 71 mm (L × W × H)'
      }]
    }
  },
  chargeStation: {
    assemble: {
      title: 'Install the automatic charging station',
      list: [{
        title: 'STEP1: ',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/assemble_station1.jpg',
        imageDesc: 'Insert the connecting strip into the charging post.'
      }, {
        title: 'STEP2: ',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/assemble_station2.jpg',
        imageDesc: 'Insert the the other end of the connecting strip into the charging pad.'
      }, {
        title: 'STEP3: ',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/assemble_station3.jpg',
        imageDesc: 'Do not place obstacles within 1.5 m in front, and 0.5 m on either side of the charging station. Avoid the charging station exposing directly to sunlight.'
      }]
    },
    use: {
      title: 'Use the auto charging station',
      list: [{
        title: 'Locating',
        descList: [{
          desc: 'Aiks can autonomously recognize the charging station. After you install the charging station, you can tap Set Charging Spot on the home page of the App and remotely direct Aiks to the front of the charging station. Aiks will then locate the charging station in your home.'
        }, {
          desc: 'If Aiks cannot charge itself autonomously, repeat the locating process, so that Aiks can acquire the location again.'
        }],
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/assemble_station_use1.jpg'
      }, {
        title: 'Charging',
        descList: [{
          desc: 'When its battery level gets low, Aiks goes to the charging station, lies down on the charging pad, and starts charging autonomously. After its battery is recharged to a certain level, Aiks stands up again, and continues to wander around or play with you.'
        }, {
          desc: 'Aiks will charge itself when you say the "Go Charging" command to it.'
        }],
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/assemble_station_use2.jpg'
      }],
      concentrateList: ['1.Make sure that Aiks acquires the location of the charging station before you enable the Guard mode. When the Guard mode is on, Aiks lies down at the charging station and stays alert to guard your home.', '2.Aiks learns about the physical world by mapping. If it is interrupted during mapping, or is relocated after it has built a map, Aiks may lose its location and will spend more time rebuilding a map to find the charging station. Therefore, we recommend that you avoid moving Aiks after it is powered on. This not only ensures that Aiks functions properly, but also protects you from potential injury of your hands or fingers.']
    },
    attention: {
      title: 'Precautions',
      listHeader: ['Precaution', 'Reason', 'Remarks'],
      list: [{
        name: 'Check whether the charging post is securely fixed before use.',
        cause: 'Insecurely fixed charging post may be tipped over by your kids or pet, causing safety risks.',
        mark: 'Where necessary, you can use the provided adhesive tape to help fix the charging post.'
      }, {
        name: 'Remove the protective film from the charging pad before use.',
        cause: 'Made of insulating materials, the film is attached to protect the metal contacts from being scratched during transportation.',
        mark: 'Remove the protective film before using the charging pad.'
      }, {
        name: 'Do not connect the two charging contacts with conductive materials.',
        cause: 'When the metal charging contacts are short-circuited, point discharge may be triggered due to circuit protection.',
        mark: 'This point effect is harmless to human health. However, we recommend that you avoid short-circuiting the metal contacts for the sake of normal operations and service life of Aiks.'
      }, {
        name: 'Do not put the charging station in direct sunlight.',
        cause: 'Aiks relies on multiple integrated sensors to locate the charging station, among which the vision sensors play an important role. Strong light may affect the locating performance, thus reducing the stability of auto charging.',
        mark: 'Prolonged exposure to direct sunlight may reduce the overall service life of the charging station. For the sake of the normal functioning and service life of Aiks and the charging station, we recommend that you install the charging station in a cool and shaded place.'
      }]
    }
  },
  smallWorld: {
    title: 'Dog House',
    assemble: {
      title: 'Install the Dog House',
      concentrate: '请保证充电桩前1.5m范围内无障碍物，否则会影响小白充电。',
      list: [{
        title: 'STEP1: ',
        desc: 'Lay the carpet flat in a suitable place and put the Dog House on it.',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/small_world1.jpg'
      }, {
        title: 'STEP2: ',
        desc: 'Insert the charging pad into the magnetic fixing hole inside the Dog House.',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/small_world2.jpg'
      }, {
        title: 'STEP3: ',
        desc: 'Do not place obstacles within 1.5 m in front, and 0.5 m on either  side of the Dog House.',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/small_world3.jpg'
      }, {
        title: 'STEP4: ',
        desc: 'Plug the charger to a power outlet, and then connect the other end of charger to the Dog House.',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/small_world4.jpg'
      }]
    },
    use: {
      useTitle: 'Use the Dog House',
      title: 'Charging with the Dog House',
      list: [{
        title: 'Locating',
        descList: [{
          desc: 'Aiks can autonomously recognize its Dog House. After you install the Dog House, you can tap Set Charging Spot on the home page of the App and remotely direct Aiks to the front of it. Aiks will then locate the Dog House in your home.'
        }, {
          desc: 'If Aiks cannot charge itself autonomously, repeat the locating process, so that Aiks can acquire the location again.'
        }]
      }, {
        title: 'Charging',
        descList: [{
          desc: 'When its battery level gets low, Aiks goes to its Dog House, lies down on the charging pad, and starts charging autonomously. After its battery is recharged to a certain level, Aiks stands up again, and continues to wander around or play with you.'
        }, {
          desc: 'Aiks will charge itself when you say the "Go Charging" command to it.'
        }]
      }],
      concentrateList: ['1.Make sure that Aiks acquires the location of the Dog House before you enable the Guard mode. When the Guard mode is on, Aiks lies down in the den and stays alert to guard your home.', '2.Aiks learns about the physical world by mapping. If it is interrupted during mapping, or is relocated after it has built a map, Aiks may lose its location and will spend more time rebuilding a map to find the den. Therefore, we recommend that you avoid moving Aiks after it is powered on. This not only ensures that Aiks functions properly, but also protects you from potential injury of your hands or fingers.']
    },
    attention: {
      title: 'Precautions',
      listHeader: ['Precaution', 'Reason', 'Remarks'],
      list: [{
        name: 'Remove the protective film from the charging pad before use.',
        cause: 'Made of insulating materials, the film is attached to protect the metal contacts from being scratched during transportation.',
        mark: 'Remove the protective film before using the charging pad.'
      }, {
        name: 'Do not connect the two charging contacts with conductive materials.',
        cause: 'When the metal charging contacts are short-circuited, point discharge may be triggered due to circuit protection.',
        mark: 'The working voltage of the Dog House is not greater than 30 VDC. Its point discharge is harmless to human health. However, we recommend that you avoid short-circuiting the metal contacts for the sake of normal operations and service life of Aiks.'
      }, {
        name: 'Do not put the Dog House in direct sunlight.',
        cause: 'Aiks relies on multiple integrated sensors to locate the den, among which the vision sensors play an important role. Strong light may affect the locating performance, thus reducing the stability of automatic charging.',
        mark: 'The Dog House is made from plant fibers and solid wood. Prolonged exposure to direct sunlight may reduce its overall service life. For the sake of the normal functioning and service life of Aiks and the Dog House, we recommend that you install the den in a cool and shaded place.'
      }]
    }
  },
  wireCharge: {
    title: 'Charging kit',
    assemble: {
      title: 'Use the charging kit',
      concentrateList: ['1.Make sure that Aiks acquires the location of the cable charging spot before you enable the Guard mode. When the Guard mode is on, Aiks lies down by the cable charging spot and stays alert to guard your home.', '2.Aiks learns about the physical world by mapping. If it is interrupted during mapping, or is relocated after it has built a map, Aiks may lose its location and will spend more time rebuilding a map to find the cable charging spot. Therefore, we recommend that you avoid moving Aiks after it is powered on. This not only ensures that Aiks functions properly, but also protects you from potential injury of your hands or fingers.'],
      list: [{
        title: 'Locating',
        descList: [{
          desc: 'Aiks can autonomously recognize the cable charging spot. You can tap Set Charging Spot on the home page of the App and remotely direct Aiks to an accessible charging spot. Aiks will then locate the charging spot in your home.'
        }, {
          desc: 'If Aiks cannot find the charging spot, repeat the locating process, so that Aiks can acquire the location again.'
        }]
      }, {
        title: 'Charging',
        descList: [{
          desc: 'When its battery level gets low, Aiks goes to the cable charging spot autonomously, waiting to be connected to the charging cable.'
        }, {
          desc: 'Aiks will also do that when you say the "Go Charging" command to it.'
        }, {
          desc: 'During cable charging, Aiks cannot stand up or execute your voice commands or remote directions.'
        }]
      }]
    }
  },
  agents: {
    title: 'Robotic dog Aiks',
    useSpeech: 'Use the speech interaction feature',
    declaration: 'Disclaimer: The output of Aiks in speech interaction is generated based on limited data on which its AI algorithm relies, and does not represent the position of WEILAN. We make no warranty as to the authenticity, accuracy, or completeness of such output.',
    connect: {
      title: 'Configure network',
      app: {
        title: 'Pair with Aiks on the App',
        desc: 'If your account has been activated and paired with a pet, and the Pair button in the Pair Pet section on the home page of the App stays available, perform the following steps.',
        list: [{
          info: 'Confirm that the current pet is activated and powered on.'
        }, {
          info: 'If you have multiple BabyAlpha, go to the home page of the App, tap Pets in the upper left corner, and choose Switch Pet and select the target pet.'
        }, {
          info: 'On the home page of the App, tap the Pair button in the Pair Pet section to pair with the pet.'
        }],
        anomaly: {
          title: 'Possible abnormality:',
          desc: 'If the pairing fails after you tap the Pair button, perform the following steps.',
          list: [{
            info: 'Tap the  icon in the upper right corner of the home page and go to General > Wi-Fi and Security. Then, tap Copy Password'
          }, {
            info: 'Go to Settings > WLAN on your phone, tap the Wi-Fi name that starts with BabyAlpha, paste the password, and connect to the Wi-Fi.'
          }]
        }
      },
      dogSetting: {
        title: 'Connect Aiks to your local Wi-Fi on the App',
        list: [{
          info: 'Make sure you have connected your phone to the Wi-Fi whose name starts with BabyAlpha'
        }, {
          info: 'Tap Network on the home page of the App.'
        }, {
          info: 'On the page that appears, select the local Wi-Fi, enter the password, and connect to it.'
        }],
        anomaly: {
          title: 'Possible abnormality: ',
          desc: 'If the pairing fails after you tap the Pair button, perform the following steps.'
        }
      },
      fourG: {
        title: '使用机器狗4G网络',
        list: [{
          info: '若您没有在 App 中匹配宠物，默认使用机器狗的4G网络。推荐您匹配宠物后为宠物配置 Wi-Fi。'
        }, {
          info: '若机器狗连接的 Wi-Fi 信号弱，您可在 App 首页的网络连接中切换 4G，使用机器狗的 4G 流量。'
        }]
      },
      concentrateList: ['1. 机器狗的 4G 网络：您可限时每月免费使用 10G 流量。您可在 App 首页=>通用=>流量查询中查看已用流量，超出后会限制使用。', '2. 机器狗的远程时长：您可限时每月免费使用 800 分钟远程时长，用于视频通话和 App 远程遥控。您可在视频通话界面查询已用时长，超出后会限制使用。'],
      changeNetwork: {
        title: '网络切换',
        list: [{
          title: 'Wi-Fi 切换 4G',
          list: [{
            info: '若机器狗连接的 Wi-Fi 信号弱，您可点击 App 宠物页面中的“切换4G”，使用机器狗的4G流量。'
          }]
        }, {
          title: '4G切换Wi-Fi',
          list: [{
            info: '若您想将机器狗的 4G 网络切换回 Wi-Fi，您可点击 App 宠物页面中的“切换 Wi-Fi”。若您想使用上次已连接成功的 Wi-Fi，请点击“一键连接”。若您想连接新的 Wi-Fi，请在“其他网络”中选择目标 Wi-Fi 及密码。'
          }]
        }, {
          title: '切换其他Wi-Fi',
          list: [{
            info: '若您想为机器狗连接新的 Wi-Fi，您可点击 App 宠物页面中的“宠物 Wi-Fi 在线”，在“其他网络”中选择目标 Wi-Fi，并输入密码。'
          }]
        }]
      }
    },
    voice: {
      title: 'Interact with Aiks by speech',
      list: [{
        info: 'Equipped with a cutting-edge and powerful LLM, Aiks can interact with you in natural languages, offering an unprecedented experience in the era of AI.'
      }, {
        info: 'You can give Aiks the following simple commands:'
      }, {
        info: 'Go Forward/Backward/Left/Right, Sit, Lie Down, Stand/Stand Up, Dance, Spin, Bow, Push Up, Shake Hand, Kick, Pee, Poop, Fart, Shake Tail, Shake Body, Play, Stretch Forward/Backward, Swim, High Five, Wave Hand, Woof Once, Play Angry, Get Up, Look At Me, Rest, Make Way, Go To Bed, Go Back, Go Charging, Go Away, and Patrol.'
      }],
      instruction: {
        desc: 'More commands will be added through OTA updates.You can also ask Aiks to do the following tasks:',
        list: [{
          info: 'To make a video call, say "make a call".'
        }, {
          info: "To check the battery level, say \"check the battery level\", \"what's the battery level now\", etc."
        }, {
          info: "To check the sound volume, say \"what's the volume\", \"current volume\", etc."
        }, {
          info: 'To adjust the sound volume, say "maximum volume", "set volume to 80", "volume down", etc.'
        }]
      }
    },
    chatMode: {
      title: '语音交互',
      desc: 'Aiks is more versatile than you can imagine. You can find more surprises interacting with it and explore more features.',
      list: [{
        desc: '1.You can wake up Aiks by calling "Hey Aiks" to start a multi-turn conversation. If you have not interacted with Aiks for more than 18 seconds, you need to wake it up again.',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/chat_mode1.jpg'
      }, {
        desc: '2.Aiks will look up and listen to you carefully. We recommend that you talk to Aiks in a quiet environment. Noise will affect speech recognition accuracy.',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/chat_mode2.jpg'
      }, {
        desc: '3.Aiks responds to your speech within 0.5 seconds. Network latency may cause a lag.',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/chat_mode3.jpg'
      }, {
        desc: '4.Aiks will wiggle while answering your questions. Thanks to its rich knowledge base, Aiks can respond to many of your requests.',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/chat_mode4.jpg'
      }, {
        desc: '5.At present, Aiks can execute only one command at a time. We will constantly update its command library for you to find more fun with Aiks.',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/chat_mode5.jpg'
      }, {
        desc: "6.You can touch the back of Aiks' head to exit speech interaction. When no one is interacting with Aiks, it wanders around, invites you to play, or rests at the charging station or Dog House.",
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/chat_mode6.jpg'
      }]
    },
    immerseChat: {
      title: '沉浸式聊天',
      desc: '沉浸式聊天下，您可以专注地长时间和小白进行中英文对话。期间，小白不会随意走动，会认真陪伴您。',
      list: [{
        desc: '1. 您可通过对小白说“沉浸式聊天”或在 App 的蔚蓝实验室中开启此模式，开始与小白专注的聊天时间。',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/immerse_chat1.jpg'
      }, {
        desc: '2. 触摸小白的后脑勺，可以进入安静的治愈陪伴时间。',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/immerse_chat2.jpg'
      }, {
        desc: '3. 您可通过触摸小白的下巴唤醒小白，继续聊天。',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/immerse_chat3.jpg'
      }, {
        desc: '4. 您可通过对小白说“退出沉浸式聊天”或在 App 中关闭此模式。',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/immerse_chat4.jpg'
      }]
    },
    // instructionMode: {
    //   title: '指令模式',
    //   use: {
    //     desc: '指令模式下，小白可以完成聊天模式中的全部指令。除此之外，它还可以完成以下语音指令：',
    //     descList: [{
    //       desc: '向左/右/后转、向左/右/前/后走、转圈、踢球、呼叫、叫、凶人、玩耍、起床、干活、吃早饭、放大招/绝招，点头、摇头、闭眼、睁眼、放屁、抖一抖、伸懒腰、打哈欠、匍匐前进、击掌、挥手、等一等/别捣乱'
    //     }, {
    //       desc: '更多动作即将上线。'
    //     }],
    //     instruction: {
    //       desc: '除了常规动作指令，您还可以在指令模式下，要求小白完成以下指令。',
    //       list: [{
    //         info: '视频通话，您可以和小白说“打电话”、“接电话”、“挂电话”。（详见“如何进行视频通话”章节）'
    //       }, {
    //         info: '播放音乐，您可以和小白说“放音乐”、“放一首歌”等。'
    //       }, {
    //         info: '查询音量，您可以和小白说“音量多少”、“当前音量”等。'
    //       }, {
    //         info: '调整音量，您可以和小白说“音量调到最大”、“音量调到80”、“音量调小”等。'
    //       }, {
    //         info: '调整屏幕亮度，您可以和小白说“亮度调到最大”、“亮度调低”等。'
    //       }, {
    //         info: '查询天气，您可以和小白说“天气怎么样”等。'
    //       }]
    //     }
    //   },
    //   list: [{
    //     desc: '1. 您可通过对小白说“指令模式”，或者触摸小白的下巴，自由切换聊天模式和指令模式。',
    //     url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/instruction_mode1.jpg'
    //   }, {
    //     desc: '2. 小白现在一次只能完成一个指令。小白的指令库会持续升级，您会在和小白的相处中发现更多乐趣。',
    //     url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/instruction_mode2.jpg'
    //   }, {
    //     desc: '3. 在指令模式下，小白还可以拨打电话、播放音乐、查询电量、调节音量等。',
    //     url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/instruction_mode3_new.jpg'
    //   }, {
    //     desc: '4. 摸摸小白的后脑勺可退出语音交互。小白会在空闲时间里进行小宠物行为，自己在家中随意行走，找主人玩，或者去充电桩/小世界休息。',
    //     url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/instruction_mode4.jpg'
    //   }]
    // },
    enPartner: {
      title: '英语语伴',
      desc: '英语语伴模式下，小白会全程使用英语，通过聊天、讲故事、做游戏等寓教于乐的方式激发孩子开口对话的兴趣，为孩子创造纯正的英语交流环境，打破填鸭式传统英语学习，使学习更轻松有趣。',
      list: [{
        desc: '1. 您可通过唤醒小白后，对小白说“英语语伴”或者在 App 的蔚蓝实验室中打开此功能。',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/en_partner1.jpg'
      }, {
        desc: '2. 首次开启时，请在 App 中输入孩子的基本信息，有助于小白了解孩子，根据喜好引导对话。此信息可随时修改。',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/en_partner2.jpg'
      }, {
        desc: '3. 开启后，小白会根据孩子的英语水平匹配相应词汇量，引导孩子进行英语对话，帮助孩子练习听力和口语。',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/en_partner3.jpg'
      }, {
        desc: '4. 您可通过对小白说“退出英语语伴”，或者在 App 中关闭此功能。',
        url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/en_partner4.jpg'
      }]
    },
    // changeMode: {
    //   title: '切换语音模式',
    //   list: [{
    //     desc: '1. 您可通过说“小白小白”唤醒后，和小白说“聊天模式”、“沉浸式聊天”、“指令模式”、“英语语伴”，切换不同的语音模式。'
    //   }, {
    //     desc: '2. 您可通过触摸小白的下巴，切换聊天模式和指令模式。'
    //   }, {
    //     desc: '3. 您可通过和小白说“退出”或触摸小白的后脑勺，退出语音交互。'
    //   }]
    // },
    video: {
      title: 'Make a video call',
      method: {
        list: [{
          info: {
            list: [{
              info: 'Direct Aiks to initiate a video call'
            }]
          },
          list: [{
            desc: 'You can make a video call to someone in Pet Contacts on the App by giving Aiks a command. For example, you can say "Call dad".',
            url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/video_step1_1.jpg'
          }]
        }, {
          info: {
            list: [{
              info: 'Direct Aiks to answer or hang up a video call from someone using the App'
            }]
          },
          list: [{
            desc: '1.You can ask Aiks to answer a call by giving it the command "Answer" or touching its chin.',
            url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/video_step2_1.jpg'
          }, {
            desc: '2.You can ask Aiks to hang up a call by giving it the command "Hang Up" or touching the back of its head.',
            url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/video_step2_2.jpg'
          }]
        }]
      }
    }
  },
  smallRangeActivity: {
    title: 'Enable Restricted Mobility Mode',
    list: [{
      info: 'If the autonomous behavior of Aiks bothers you, you can enable Restricted Mobility Mode on the Control Center page of the App.'
    }, {
      info: 'If you enable this feature, Aiks goes to the charging spot after the interaction and moves or rests within a 2 m × 4 m area. You can still interact with Aiks when it stays within the area.'
    }],
    concentrateList: ['1.If you have not set the charging spot when you enable this feature, Aiks goes to where you powered it on and moves or rests within a 2 m×4 m area.', '2.If you take Aiks to a new environment and then enable this feature, Aiks stands and waits where you put it down.']
  },
  autoBox: {
    title: 'Use the AutoBox',
    rereceive: {
      name: 'Have Aiks walk into AutoBox',
      desc: 'You can have Aiks walk into the AutoBox 40 minutes after it is activated. Perform the following steps.',
      concentrate: 'Make sure that Aiks is powered off after it lies down in the AutoBox. This prevents Aiks from moving inside the Autobox, which may cause personal injury and property damage.',
      list: [{
        info: 'Place Aiks within 1–2 meters in front of the AutoBox.'
      }, {
        info: 'Wait for Aiks to recognize the AutoBox, walk into it, and then lie down.'
      }, {
        info: 'Press and hold the power button on Aiks, and release the button when a beep is heard.'
      }, {
        info: 'Close the lid of the AutoBox.'
      }]
    },
    out: {
      name: 'Have Aiks walk out of the AutoBox',
      list: [{
        info: 'Put Aiks to the standard posture for startup in the AutoBox. For details, see section "Standard posture for startup".'
      }, {
        info: 'Power Aiks on in the AutoBox. For details, see section "Power Aiks on".'
      }, {
        info: 'Do not intervene when Aiks stands up and walks out of the AutoBox on its own.'
      }]
    },
    update: {
      title: 'Upgrade firmware',
      desc: 'We will constantly add more features to Aiks. After you power Aiks on, you can open the App, tap the "Upgrade My Pet" icon in the upper right corner on the home page and go to General > Upgrade Pet to upgrade its firmware. The upgrade takes about 15 minutes. When the upgrade is completed, you can enjoy the latest features.'
    }
  },
  technicalSpecifications: {
    title: 'Technical Specifications',
    desc: 'Physical parameters',
    listHeader: ['Parameter', 'Value'],
    list: [
      {
        name: 'Weight',
        value: '8.5–8.8 kg'
      },
      {
        name: 'Dimensions (standing)',
        value: '572 x 298 x 525mm'
      },
      {
        name: 'Dimensions (standing up straight)',
        value: '550 x 298 x 555mm'
      },
      {
        name: 'Dimensions (lying down)',
        value: '625 mm x 333 mm x 328 mm'
      },
      {
        name: 'Degrees of Freedom (DF)',
        value: '12'
      },
      {
        name: 'Screen size',
        value: '3.5 inches'
      },
      {
        name: 'Screen Resolution',
        value: '480 x 800'
      },
      {
        name: 'RAM',
        value: '8 GB'
      },
      {
        name: 'Flash memory',
        value: '64 GB'
      },
      {
        name: 'ROM',
        value: '128 GB–1 TB'
      },
      {
        name: 'Wi-Fi',
        value: 'Wi-Fi 5 IEEE 802.11 a/b/g/n/ac'
      },
      {
        name: 'Bluetooth',
        value: 'Bluetooth 5.0'
      },
      {
        name: 'OS',
        value: 'Ubuntu 20.04 + ROS'
      },
      {
        name: 'Wide-angle vision',
        value: '2MP FOV: 120°'
      },
      {
        name: 'Active infrared vision',
        value: '2MP FOV: 90°'
      },
      {
        name: 'Microphone array',
        value: 'Supported'
      },
      {
        name: 'Multipoint touch sensor',
        value: 'Supported'
      },
      {
        name: 'Temperature and humidity sensor',
        value: 'Supported'
      },
      {
        name: '6DF IMU sensor',
        value: 'Supported'
      },
      {
        name: 'Joint torque sensor',
        value: 'Supported'
      },
      {
        name: 'Motion detection radar',
        value: 'Max. detection range: 4 m'
      },
      {
        name: '360-degree lidar',
        value: 'Max. detection range: 8 m'
      },
      {
        name: 'Multi-ToF radar',
        value: 'Supported'
      },
      {
        name: '6D pose estimation',
        value: 'Supported'
      },
      {
        name: 'Overall battery life',
        value: '60–120 min'
      },
      {
        name: 'Max. standby time',
        value: 'Approx. 4–6 h'
      },
      {
        name: 'Fast charging time',
        value: 'Approximately 90 min'
      },
      {
        name: 'Max. forward speed',
        value: '3.6–7.2 km/h'
      },
      {
        name: 'Max. climbing angle',
        value: '20°'
      },
      {
        name: 'Dynamic balance',
        value: 'Supported'
      },
      {
        name: 'Self-recovery from falls',
        value: 'Supported'
      },
      {
        name: 'Fall protection',
        value: 'Supported'
      },
      {
        name: 'Displacement sensor',
        value: 'Supported'
      },
      {
        name: 'Fast charging',
        value: 'Supported'
      },
      {
        name: 'Fingertip controller',
        value: 'Supported'
      },
      {
        name: 'Operating temperature',
        value: '0–35°C'
      },
      {
        name: 'Storage temperature',
        value: '-10°C to 45°C'
      },
      {
        name: 'Charging ambient temperature',
        value: '5–30°C'
      }
    ]
  },
  nineTitle: 'Safety and legal information',
  securityLegal: {
    title: 'Instructions for safe use and maintenance',
    legalNotices: {
      title: 'Legal notices',
      list: [{
        info: 'Before using the robot, read through this manual carefully and operate it as instructed.'
      }, {
        info: 'Operators of the robot should be at least 14 years old and have appropriate cognitive and behavioral abilities. For details, see section "Operator requirements"'
      }, {
        info: 'WEILAN and its affiliates shall not be liable for any personal injury or property damage caused by robot operations that are in violation of this manual.'
      }, {
        info: 'For details about user privacy and other related issues, see the WEILAN Privacy Policy App, and End-User License Agreement. We recommend that you read them carefully.'
      }, {
        info: 'The robot described in this manual are intended to show users how to correctly operate a robot. Therefore, the robot displayed in images or videos may be different from the ones you have bought or received in terms of the color, appearance, and other aspects. '
      }, {
        info: 'To keep improving the product features and your experience, we will be constantly upgrading and optimizing our robot. The soft copy of this user manual is accessible from our official website and WEILAN App, and will be updated from time to time. '
      }, {
        info: 'Users should comply with local laws and regulations when using WEILAN robots. Users should not use the robots to harm people or animals, and should not modify or use them as a weapon. Otherwise, your product warranty and other customer benefits are annulled.'
      }]
    },
    attention: {
      attentionTitle: 'Precautions',
      list: [{
        info: 'To minimize the risk of injury, always check the conditions of Aiks before operating it.'
      }, {
        info: 'Power on Aiks on a flat surface. To avoid loss of control or collision, do not abruptly change its speed. '
      }, {
        info: 'Stay alert when operating Aiks. Keep Aiks within your sight to avoid hitting people or properties.'
      }, {
        info: 'Steer Aiks at an appropriate speed and always keep it in a safe distance from people or objects. Slow it down when it enters a new environment.'
      }, {
        info: 'To avoid distractions while operating Aiks, do not wear headphones or earplugs, or do anything not related to the operation, such as answering calls, taking photos, or shooting videos with your phone. This way, you can keep an eye on your surroundings.'
      }, {
        info: 'Stay alert when operating Aiks in environments with poor visibility to avoid personal injury and property damage.  '
      }, {
        info: 'Do not operate Aiks on slippery surfaces such as ice and glass.'
      }, {
        info: 'Do not operate Aiks in high or narrow places, such as desktops and beds, to prevent it from falling.'
      }, {
        info: 'Slow it down when Aiks makes a turn to prevent it from being out of control.'
      }, {
        info: 'Do not operate Aiks if any of its parts is damaged.'
      }, {
        info: 'To avoid personal injury, do not interfere with the normal operation of Aiks.'
      }, {
        info: 'To avoid personal injury or property damage, do not ride Aiks.'
      }, {
        info: 'To avoid personal injury or property damage, do not load heavy objects onto Aiks.'
      }, {
        info: 'Do not pull soft parts of Aiks, such as its ears and tail. Otherwise, Aiks may fall, causing personal injury or property damage.'
      }, {
        info: 'Do not modify or disassemble Aiks without authorization.'
      }, {
        info: 'Do not use third-party parts for replacement or install such parts to Aiks.'
      }, {
        info: 'Do not install third-party parts, which may cause compatibility and reliability issues.'
      }, {
        info: 'Avoid incidents that may result in damage to Aiks, such as immersion, ingress of foreign matter, contact with chemicals, and scratching.'
      }, {
        info: 'To prevent liquid from entering the battery, circuits, chips, and other parts, do not jet wash Aiks.'
      }, {
        info: 'If Aiks has been drenched in rain or experienced liquid ingress, power it off immediately and do not power it on again. Do not perform operations on Aiks by yourself except for wiping it. Improper operations may cause further damage to Aiks or invalidate the warranty. In this case, contact WEILAN after-sales service.'
      }, {
        info: 'To avoid impairment to the battery performance, do not leave Aiks sitting unpowered for long. '
      }, {
        info: 'Do not repair parts or modify circuits or battery packs without authorization, or use the charger improperly.'
      }, {
        info: 'To avoid wireless devices or signals interfering with the operation of Aiks, do not use Aiks in or near an environment with complex electromagnetic conditions or strong interference sources, such as mining areas, radio towers, HV lines, substations, or radioactive places.'
      }, {
        info: 'Do not install third-party apps on BabyAlpha products.'
      }, {
        info: 'Do not use any unofficial operating systems or update packages, which may pose a safety risk.'
      }]
    },
    sportAttention: {
      sportAttentionTitle: 'When using BabyAlpha outdoors, please keep in mind:',
      list: [{
        info: 'To avoid damage to the battery or circuits, or spontaneous combustion or explosion, do not operate Aiks under harsh conditions, such as bad weather (such as wind, rain, snow), dusty or muddy fields, corrosive environment, and extreme temperatures.'
      }, {
        info: 'We recommend that you use Aiks at a partly enclosed place with hard ground, such as asphalt road, ceramic tile flooring, and rubber running track.'
      }, {
        info: 'To avoid traffic accidents or other adverse consequences, do not operate Aiks on public roads.'
      }, {
        info: 'Steer Aiks with caution when it navigates through a new environment or a place with complex conditions, such as a road with obstacles and bumps.'
      }, {
        info: 'Do not operate Aiks near obstacles such as vehicles, pedestrians, puddles, or pools.'
      }, {
        info: 'When Aiks approaches or passes through intersections, turns, and entrances on private roads, slow it down and take precautions to avoid pedestrians, animals, or vehicles.'
      }, {
        info: 'When passing through an unidentified cover, check the ground underneath the cover beforehand to ensure that Aiks passes through safely. '
      }]
    },
    declaration: "If you use Aiks in violation of the above instructions, it may cause damage to Aiks or to your and other people's personal and property safety, and it may also lead to the loss of free after-sales service for Aiks under warranty."
  },
  maintenance: {
    title: 'Maintenance',
    routineMaintenance: 'Routine maintenance',
    afterManipulation: {
      title: 'Maintenance after use',
      list: [{
        info: 'Steer Aiks to a flat surface before powering it off.'
      }, {
        info: 'Do not put Aiks into the Autobox when it is powered on. '
      }, {
        info: 'Charge Aiks with the official WEILAN charger to avoid damage to the battery or the risk of fire. '
      }]
    },
    replacement: 'Regular maintenance or replacement',
    host: {
      hostTitle: 'Primary device',
      descList: [{
        desc: 'Check all parts of Aiks and make sure that they are in good condition. If you need any help, contact WEILAN after-sales service. '
      }, {
        desc: 'Before maintenance, make sure that Aiks is powered off and disconnected from the charger.'
      }],
      list: [{
        info: 'Use original parts for replacement to avoid damage to Aiks due to compatibility issues. '
      }, {
        info: 'Paw pads are consumables. If paw pads are worn, torn, incomplete, or peeled off, Aiks may be unstable when it moves or stands.'
      }, {
        info: 'Clean the surface of camera, sensors, and other parts of Aiks regularly.  '
      }, {
        info: 'Check the level and health condition of the battery regularly. If the battery life is significantly shortened, contact WEILAN customer service for a replacement.'
      }, {
        info: 'Store Aiks and the power adapter in a cool and dry place.  '
      }]
    },
    battery: {
      batteryTitle: 'Battery',
      list: [{
        info: 'Do not store the battery under temperatures higher than 45°C or lower than –10°C. If the battery is left unused for long, its performance will be impaired.'
      }, {
        info: 'If you expect that the battery will be left unused for more than 3 months, we recommend that you store it under favorable conditions (20–25°C temperature and 0–60% RH), and keep the battery level no higher than 80%, preferably 30–50%.'
      }, {
        info: 'During the storage, check the battery level regularly, and charge it if the battery level falls below 20%. We recommend that you charge the battery at least once every 3 months to maintain its performance.'
      }, {
        info: 'We recommend that you charge the battery at 10–25°C.'
      }, {
        info: 'Do not charge the battery for more than 24 hours. Overcharging will shorten the battery life.'
      }, {
        info: 'If under-voltage protection is triggered, the battery will not supply power until it is properly charged.'
      }, {
        info: 'Do not over-discharge the battery. Otherwise, the battery will no longer be recharged.'
      }, {
        info: 'The charging automatically stops when the battery is fully charged. We recommend that you disconnect the device from the charging kit after it is fully charged.'
      }]
    }
  },
  elevenTitle: 'Troubleshooting',
  question: {
    title: 'Common issues and solutions',
    list: [{
      title: 'What can I do if the image of the LCD screen disappears and the indicators go off when Aiks is starting?',
      desc: 'The battery level is low and Aiks enters the low power protection mode. You need to charge Aiks with WEILAN charging kit for about 1.5 hours.'
    }, {
      title: 'How do I know that my Aiks has been powered on successfully?',
      desc: 'When starting, Aiks plays bootsplash and audio prompts. The start process is completed when the bootsplash ends and facial expression is displayed on the screen.'
    }, {
      title: 'Why does Aiks stop moving and lie down when I press the hump on its back?',
      desc: 'That hump is the Emergency Stop button. If you press it in an emergency, Aiks gradually loses power and finally lies down to ensure safety.'
    }, {
      title: 'Can I walk my Aiks on a leash?',
      desc: 'The current software version of Aiks does not support leash control.'
    }, {
      title: 'I bought a new fingertip controller to replace the broken original one. What can I do to control Aiks with the new controller?  ',
      desc: 'You must pair the new fingertip controller with Aiks. For details, see section "Pair with the controller".'
    }, {
      title: 'Aiks moves so slowly when controlled with the fingertip controller. What can I do to make it go faster?',
      desc: 'The fingertip controller supports fast mode and slow mode. By default, the slow mode is used. To have Aiks move faster, press the Speed Adjust button on the controller. After you switch the speed mode, take some time to break in. Do not push or pull the joystick too much; otherwise, Aiks will rush out and may cause collisions.'
    }, {
      title: 'What can I do if the fingertip controller does not work every now and then?',
      desc: 'The effective working range of the controller is 5 m. In an open area, the control range can reach 10 m. The controller may be disconnected from Aiks if there are people moving around or metal obstacles, which seriously disturb the signal transmission. When the controller is within the minimum communication range from Aiks, it automatically connects to Aiks again. We recommend that you keep the distance between Aiks and the controller within 10 m in an open area.'
    }, {
      title: 'Aiks keeps hitting on objects. What can I do if Aiks can no longer detect or get around obstacles?',
      descList: [{
        desc: '1. Check whether the sensor in the chin and lidars on its back and head are blocked. If yes, remove the blockage.'
      }, {
        desc: '2. Manual control through the joystick or App has higher priority over auxiliary features, such as obstacle avoidance. When Aiks is under manual control, autonomous obstacle avoidance is turned off. In this case, Aiks may hit on objects.'
      }, {
        desc: '3. Aiks relies on multiple sensors, such as vision sensors, detection radars, ToF radars to recognize and avoid obstacles. Aiks can hardly recognize particularly small or transparent obstacles, resulting in failure to avoid obstacles.'
      }]
    }, {
      title: 'I can wake up Aiks by voice, but Aiks just replies "Yes" without further talking with me. What should I do?',
      descList: [{
        desc: '1. Check whether the network signal is weak. Aiks relies on Wi-Fi communication. Poor network condition may cause a speech interaction lag or interruption.'
      }, {
        desc: "2. Check whether Aiks is using a private Wi-Fi network. Some private Wi-Fi networks may be protected by firewalls, which can block Aiks' speech interaction requests."
      }]
    }]
  },
  help: {
    title: 'Help and feedback',
    desc: 'If you have any questions or need any help when using our products, contact us at any time through the following ways:',
    officia: {
      title: 'Official website: ',
      value: 'www.weilan.com/en/'
    },
    email: {
      title: 'Email: ',
      value: 'overseas_support@weilan.com'
    },
    info: 'You are also welcome to share with us any comments or suggestions about the WEILAN robots. We sincerely look forward to your valuable feedback. Your understanding and support fuel our progress.',
    weChatQRCode: {
      desc: '蔚蓝微信公众号，扫码获取帮助',
      url: 'https://resources-' + domain + '.' + getSecondLevelDomain() + '.com/static/instruction/we_chat_QRCode.jpg'
    }
  }
}
export default en



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js